<template>
    <div>
        <template v-if="accountname">
        <h1>Direct Debit Authorizations</h1>
        <DirectDebitLogo/><br/>
        powered by <a href="https://bitshares.org/">BitShares</a> & <a href="https://github.com/bitshares/beet">Beet</a>
        <div v-if="account">
            <h2>Account Name</h2>
            <BitSharesAccount :name="account.name" />
        </div>
        <div>
            <h2>Incoming authorizations <b-button v-if="receiving">Collect all</b-button></h2>
            <template  v-if="receiving">
                <div class="table" v-for="item in receiving" :key="item.id">
                    <span>
                        <BitSharesAccount :name="item.withdraw_from_account" />
                    </span>
                    <span>
                        <BitSharesAccount :name="item.authorized_account" />
                    </span>
                    <span>{{ (item.withdrawal_limit.amount/Math.pow(10, item.withdrawal_limit.asset.precision)) + " " + item.withdrawal_limit.asset.symbol }}</span>
                    <span>{{ item.period_start_time }}</span>
                    <span>
                        <b-button>Collect</b-button>
                    </span>
                </div>
            </template>
            <div v-else>
                No authorizations
            </div>
        </div>
        <div>
            <h2>Outgoing authorizations <b-button>Create</b-button></h2>
            <template v-if="sending">
                <div class="table" v-for="item in sending" :key="item.id">
                    <span><BitSharesAccount :name="item.withdraw_from_account" /></span>
                    <span><BitSharesAccount :name="item.authorized_account" /></span>
                    <span>{{ (item.withdrawal_limit.amount/Math.pow(10, item.withdrawal_limit.asset.precision)) + " " + item.withdrawal_limit.asset.symbol }}</span>
                    <span>{{ item.period_start_time }}</span>
                    <span>
                        <b-button>Edit</b-button>
                        <b-button>Cancel</b-button>
                    </span>
                </div>
            </template>
            <div v-else>
                No authorizations
            </div>
        </div>
        </template>
        <template v-else>Please login or add an account name in the address for observation (e.g. "/overview/youraccountname")</template>
    </div>
</template>

<script>
    import DirectDebitLogo from "./DirectDebitLogo";
    import {ChainStore, FetchChain} from 'bitsharesjs/es';
    import {Apis} from "bitsharesjs-ws";
    import chain from '@/chain';
    import BitSharesAccount from "./BitSharesAccount";

    export default {
        name: "DirectDebitOverview",
        components: {BitSharesAccount, DirectDebitLogo},
        props: {
            accountname: String
        },
        data() {
            return {
                account: null,
                receiving: null,
                sending: null
            }
        },
        async mounted() {
            if (this.accountname) {
                await chain.connect();
                await this.loaded();
            }
        },
        methods: {
            async loaded() {
                let account = (await FetchChain("getAccount", this.accountname));
                this.account = account.toJS();
                let receiving = await Apis.instance().db_api().exec("get_withdraw_permissions_by_recipient", [
                    this.account.id,
                    "1.12.0",
                    100
                ]);
                if (receiving.length > 0) {
                    for (let index = 0; index < receiving.length; index++) {
                        let item = receiving[index];
                        item.authorized_account = this.account.name;
                        item.withdraw_from_account = (await FetchChain("getAccountName", item.withdraw_from_account));
                        item.withdrawal_limit.asset = (await FetchChain("getAsset", item.withdrawal_limit.asset_id)).toJS()
                    }
                    this.receiving = receiving;
                }
                let sending = await Apis.instance().db_api().exec("get_withdraw_permissions_by_giver", [
                    this.account.id,
                    "1.12.0",
                    100
                ]);
                if (sending.length > 0) {
                    for (let index = 0; index < sending.length; index++) {
                        let item = sending[index];
                        item.authorized_account = (await FetchChain("getAccountName", item.authorized_account));
                        item.withdraw_from_account = this.account.name;
                        item.withdrawal_limit.asset = (await FetchChain("getAsset", item.withdrawal_limit.asset_id)).toJS();
                    }
                    this.sending = sending;
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .table {
        > span {
            margin-left: 1rem
        }
    }
</style>
